// phonics_data_lt24.js
// Letter Teams L24 - L24 R controlled Vowels er, ir, ur Bossy r
// 路由：/phonics/lt24

const MEDIA_BASE = '/media/phonics/lt24';
const V = 'v1';

export const letterDataLt24 = {
  id: 'lt24',
  letter: 'L24',
  title: 'L24 R controlled Vowels er, ir, ur Bossy r',
  mediaBase: MEDIA_BASE,

  part1Video: { src: `${MEDIA_BASE}/part1.mp4?${V}` },
  part3Video: { src: `${MEDIA_BASE}/part3.mp4?${V}` },
  reviewPic: { src: `${MEDIA_BASE}/review.png?${V}` },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It is summer.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The pals see a girl.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "She has a white shirt.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Wow. She can surf!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Let's surf too!", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Green goes first.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Wow. Green is good.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "It's my turn.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "No. It's her turn.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "You will go third.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Yellow surfs on a wave.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Then Pink surfs.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "I am better than you!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "Give me a turn!", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
        { en: "Let's all surf.", audioEn: `${MEDIA_BASE}/story2_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "A big wave comes up.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Oh no!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "The pals are hurt.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Help! Help!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Here comes a nurse!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "The nurse helps the pals.", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "They are better now!", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
      ],
    },
  ],
};
